import {type MutationTree} from 'vuex';

const mutations: MutationTree<TimeTrackerState> = {
    setState(state, newState)
    {
        state.currentState = newState;
    },
    setLocked(state, newState)
    {
        state.locked = newState;
    },
    setLastUpdate(state, newLastUpdate)
    {
        state.lastUpdate = newLastUpdate;
    },
    setData(state, data)
    {
        for (let key in data)
        {
            if (data.hasOwnProperty(key) && state.hasOwnProperty(key))
            {
                state[key] = data[key];
            }
        }
    },
};

export default mutations;
